
import { Component, Prop } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CardBody from '@/components/card-body/index.vue'
import Fleet from '@/entities/fleet'
import User from '@/entities/user'
import dayjs from 'dayjs'

@Component({
  components: { CardBody }
})
export default class LookupEdit extends AbpBase {
  /**
   * 组件名称
   */
  name: string = 'Fleet Edit'

  fleet: Fleet = new Fleet()

  rules = {
    vehicleNo: [
      {
        required: true,
        message: 'Please input Vehicle No',
        trigger: 'blur'
      }
    ],
    isActive: [
      {
        required: true,
        message: 'Please select Status',
        trigger: 'change'
      }
    ]
  }

  appRoleList: Array<User> = []

  async getAppRoles() {
    let res = await this.$store.dispatch({
      type: 'fleet/getAppRole',
      appRole: 'Driver'
    })
    this.appRoleList = (res || []).map(t => {
      return {
        label: t.userName,
        value: t.id
      }
    })
  }

  // 新建或更新
  doCreateOrUpdate() {
    ;(this.$refs.form as any).validate(async (valid: boolean) => {
      if (!valid) {
        return
      }
      if (this.fleet.purchaseDate) {
        this.fleet.purchaseDate = dayjs(this.fleet.purchaseDate).format(
          'YYYY-MM-DDTHH:mm:ssZ[Z]'
        )
      }
      this.createOrUpdateLookup({
        fleet: this.fleet
      })
    })
  }
  // 调用接口
  async createOrUpdateLookup(data) {
    await this.$store.dispatch({
      type: 'fleet/createOrUpdateFleet',
      data: data
    })
    this.$notify.success({
      title: 'Success',
      message: 'Save Success'
    })
    this.doCancel()
  }

  doCancel() {
    ;(this.$refs.form as any).resetFields()
    this.$router.back()
  }

  loading = false

  async created() {
    try {
      this.loading = true
      this.getAppRoles()
      let id = +this.$route.params.id
      if (!id || id < 0) {
        // 新增
        this.fleet.isActive = true
        return
      }
      // 编辑
      this.fleet.id = +id
      let res = await this.$store.dispatch({
        type: 'fleet/get',
        id: this.$route.params.id
      })
      this.fleet = res.fleet
    } catch (e) {
      console.log(e);
    } finally{
      this.loading = false
    }
  }
}
